import { withStyles } from '@material-ui/styles';
import { flowRight } from 'lodash';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';

import checkNumberData from '../../../utils/checkNumberData';
import { createValueLabel, mapValue } from '../actions/dataActions';
import styles from '../styles/generalData';
import CustomTitle from './CustomTitle';
import Optional from '../../../utils/optional';
import { formatDateForSchedule } from '../../../utils/formatDate';

function CarrierCharacteristics({
  classes,
  carrierData = {},
  fromRightPanel = false,
  rightPanelData = {}
}) {
  const { isDataExist, data } = useMemo(() => {
    return checkNumberData({
      numberData: carrierData,
      rightPanelData,
      fromRightPanel
    });
  }, [carrierData, rightPanelData, fromRightPanel]);

  return (
    <div className={classes.root}>
      <CustomTitle title="CHARACTERISTICS" isDataExist={isDataExist}>
        {isDataExist && (
          <div>
            {Array.isArray(data) &&
              data.map((el, i) => {
                const { name, displayValue } = el;
                return (
                  <div
                    className={classes.dataContainer}
                    key={i}
                    style={{
                      backgroundColor: i % 2 === 0 ? '#FFF' : '#FAFAFA'
                    }}
                  >
                    <div className={classes.dataKey}>{name}</div>
                    <div>
                      {Array.isArray(displayValue)
                        ? Optional(displayValue[0]).or('')
                        : ''}
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </CustomTitle>
    </div>
  );
}

const mapStatesToProps = ({ checkNumber, rightPanel, auth }) => {
  return {
    carrierData: checkNumber?.carrierData?.characteristics,
    rightPanelData: rightPanel?.number?.carrierData?.characteristics,
    lang: auth.lang
  };
};

export default flowRight(
  connect(mapStatesToProps),
  withStyles(styles)
)(CarrierCharacteristics);
